// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAllowIndividualContributionsPropertyDto
 */
export interface IAllowIndividualContributionsPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IAllowIndividualContributionsPropertyDto
     */
    allow_individual_contributions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAllowIndividualContributionsPropertyDto
     */
    allow_individual_contributions_state_id?: IAllowIndividualContributionsPropertyDtoAllowIndividualContributionsStateIdEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAllowIndividualContributionsPropertyDtoAllowIndividualContributionsStateIdEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAllowIndividualContributionsPropertyDto interface.
 */
export function instanceOfIAllowIndividualContributionsPropertyDto(value: object): value is IAllowIndividualContributionsPropertyDto {
    return true;
}

export function IAllowIndividualContributionsPropertyDtoFromJSON(json: any): IAllowIndividualContributionsPropertyDto {
    return IAllowIndividualContributionsPropertyDtoFromJSONTyped(json, false);
}

export function IAllowIndividualContributionsPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAllowIndividualContributionsPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allow_individual_contributions': json['allow_individual_contributions'] == null ? undefined : json['allow_individual_contributions'],
        'allow_individual_contributions_state_id': json['allow_individual_contributions_state_id'] == null ? undefined : json['allow_individual_contributions_state_id'],
    };
}

export function IAllowIndividualContributionsPropertyDtoToJSON(json: any): IAllowIndividualContributionsPropertyDto {
    return IAllowIndividualContributionsPropertyDtoToJSONTyped(json, false);
}

export function IAllowIndividualContributionsPropertyDtoToJSONTyped(value?: IAllowIndividualContributionsPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allow_individual_contributions': value['allow_individual_contributions'],
        'allow_individual_contributions_state_id': value['allow_individual_contributions_state_id'],
    };
}

